import { render, staticRenderFns } from "./VehicleAvatar.vue?vue&type=template&id=64954ff7&lang=pug&"
import script from "./VehicleAvatar.vue?vue&type=script&lang=ts&"
export * from "./VehicleAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports